"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.dataCy = void 0;
var _StepIcon = _interopRequireDefault(require("./StepIcon"));
var _StepLabel = _interopRequireDefault(require("@mui/material/StepLabel"));
var _styles = require("@mui/styles");
var _react = _interopRequireDefault(require("react"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var dataCy = exports.dataCy = "StepLabel";
var styles = function styles() {
  return {
    iconContainer: {
      paddingRight: 24
    }
  };
};
var StepLabel = function StepLabel(_ref) {
  var children = _ref.children,
    classes = _ref.classes,
    color = _ref.color,
    active = _ref.active,
    alternativeLabel = _ref.alternativeLabel,
    completed = _ref.completed,
    disabled = _ref.disabled,
    expanded = _ref.expanded,
    icon = _ref.icon,
    last = _ref.last,
    orientation = _ref.orientation;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_StepLabel["default"], {
    "data-cy": dataCy,
    StepIconComponent: _StepIcon["default"],
    StepIconProps: {
      color: color
    },
    classes: classes,
    active: active,
    alternativeLabel: alternativeLabel,
    completed: completed,
    disabled: disabled,
    expanded: expanded,
    icon: icon,
    last: last,
    orientation: orientation,
    children: children
  });
};
var _default = exports["default"] = (0, _styles.withStyles)(styles)(StepLabel);